import React from 'react';
import { X } from 'lucide-react';
import BrandDropdown from 'shared/components/ui/BrandDropdown';
import { AddControlButton, QUERY_PANEL_CLASS, QUERY_SECTION_BODY_CLASS } from 'shared/components/filters/queryBuilderChrome';
import { FILTER_OPS, VALUELESS, filterFields } from 'features/datasets/utils/rowFilter';

let _fid = 0;
export const newFilter = () => ({ id: `f${Date.now().toString(36)}_${_fid++}`, field: '__expected', operator: 'contains', value: '' });

/**
 * The row filter: the same builder the runs and spans pages use, one condition
 * per line (where / and, field, operator, value). Conditions are ANDed and
 * narrow the grid at once; a condition with no value yet does nothing.
 */
export default function DatasetFilter({ filters, columns, onChange }) {
  const fields = filterFields();
  const update = (id, patch) => onChange(filters.map((f) => (f.id === id ? { ...f, ...patch } : f)));
  return (
    <div className={`${QUERY_PANEL_CLASS} mx-3 my-2`}>
      <div className={QUERY_SECTION_BODY_CLASS}>
        {filters.map((f, idx) => (
          <div key={f.id} className="flex flex-wrap items-center gap-2">
            <span className="w-10 px-0.5 text-[11px] text-[color:var(--text-muted)]">{idx === 0 ? 'where' : 'and'}</span>
            <div style={{ minWidth: 120, width: 'max-content' }}>
              <BrandDropdown value={f.field} compact ariaLabel="Filter field" menuMinWidth={200} options={fields}
                onChange={(field) => update(f.id, { field })} />
            </div>
            <div style={{ minWidth: 120, width: 'max-content' }}>
              <BrandDropdown value={f.operator} compact ariaLabel="Filter operator" menuMinWidth={180} options={FILTER_OPS}
                onChange={(operator) => update(f.id, { operator, ...(VALUELESS.has(operator) ? { value: '' } : {}) })} />
            </div>
            {VALUELESS.has(f.operator) ? null : (
              <input value={f.value} onChange={(e) => update(f.id, { value: e.target.value })} placeholder="Value" aria-label="Filter value"
                className="h-8 w-44 rounded-md border border-[color:var(--border-default)] bg-[color:var(--surface-base)] px-2.5 text-[12px] text-[color:var(--text-primary)] outline-none placeholder:text-[color:var(--text-disabled)] focus:border-[color:var(--border-strong)]" />
            )}
            <button type="button" onClick={() => onChange(filters.filter((x) => x.id !== f.id))} aria-label="Remove filter"
              className="rounded p-1 text-[color:var(--text-muted)] hover:bg-surface-hover hover:text-[color:var(--text-primary)]"><X size={13} /></button>
          </div>
        ))}
        <div><AddControlButton onClick={() => onChange([...filters, newFilter()])} /></div>
      </div>
    </div>
  );
}
